import React, { useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useCRM } from '../context/CRMContext';
import { Opportunity as Lead } from '../types';
import { ArrowLeft } from 'lucide-react';

const AccountLeads: React.FC = () => {
  useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const { account } = location.state || {};
  const { opportunities } = useCRM();

  const accountLeads = useMemo(() => {
    if (!account) return [];
    return opportunities.filter((op: Lead) => op.companyName === account.name);
  }, [opportunities, account]);

  if (!account) {
    // In a real app, you might fetch the account details here using the accountId
    return <div>Account not found.</div>;
  }

  return (
    <div className="p-6 bg-gray-50 min-h-full">
        <div className="flex items-center mb-6">
            <button onClick={() => navigate('/accounts')} className="p-2 rounded-full hover:bg-gray-200 mr-4">
                <ArrowLeft size={20} />
            </button>
            <h1 className="text-2xl font-bold text-gray-800">Leads for {account.name}</h1>
        </div>

        <div className="bg-white shadow-sm rounded-lg">
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contact Name</th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Deal Stage</th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Expected Deal Size</th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sales Rep</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {accountLeads.length > 0 ? (
                            accountLeads.map((lead) => (
                                <tr key={lead.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => navigate(`/leads/${lead.id}`)}>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{lead.contactName || 'N/A'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{lead.dealStage}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{lead.expectedDealSize}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{lead.salesRep}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={4} className="text-center py-10 text-gray-500">
                                    No leads found for this account.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  );
};

export default AccountLeads;
